export enum EMetricaDataType {
  ADULTS = 'adults',
  TEENAGERS = 'teenagers',
  COUPLES = 'couples',
  GROUP_SESSIONS = 'group sessions',
}

export const metricaDataConfig: Record<string, string> = {
  [EMetricaDataType.ADULTS]: 'adult',
  [EMetricaDataType.TEENAGERS]: 'kids',
  [EMetricaDataType.COUPLES]: 'pairs',
  [EMetricaDataType.GROUP_SESSIONS]: 'group',
};
